import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-1.5,-8h0.5v0.5h-0.5zM-2,-7.5h4v0.5h-4zM-0.5,-7h1.5v0.5h-1.5zM-0.5,-6.5h1v0.5h-1zM0,-2.5h0.5v1h-0.5z',
    },
    {
      paint: 'beehive',
      d: 'M-1,-6h1.5v0.5h-1.5zM-1.5,-5.5h1v0.5h-1zM0,-5.5h1v0.5h-1zM-1.5,-5h0.5v0.5h-0.5zM-0.5,-5h2v0.5h-2zM-2,-4.5h1v0.5h-1zM-0.5,-4.5h2.5v2h-2.5zM-2,-4h0.5v1.5h-0.5zM-2,-2.5h2v0.5h-2zM0.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h1.5v0.5h-1.5zM0.5,-2h1v0.5h-1zM-1,-1.5h2.5v0.5h-2.5z',
    },
    { paint: 'wheat', d: 'M-0.5,-5.5h0.5v0.5h-0.5zM-1,-5h0.5v1h-0.5zM-1.5,-4h1v1.5h-1z' },
  ],
  pixels: 79,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
